// Sample Venue data

export interface Venue {
  id: number
  name: string
  type: string
  location: string
  description: string
  img: string
  capacity: number
  rate: number
  amenities: string []
  starrating: number | "Not rated"
  contactphone: string
  contactemail: string
}

export const sampleVenues: Venue[] = [
  {
    id: 1,
    name: "Grand Plaza Hotel",
    type: "Hotel",
    img: "https://image2url.com/images/1757496861500-4e3c6f3c-1f4e-4d1e-8b1e-3c9f0b8e5f4a.jpg",
    starrating: 4.8,
    location: "Hyderabad",
    capacity: 500,
    rate: 2500,
    description: "Luxury hotel with premium event facilities",
    amenities: ["WiFi", "Projector", "Catering", "Parking"],
    contactphone: "+1-555-0123",
    contactemail: "events@grandplaza.com",
  },
  {
    id: 2,
    name: "Jay Convention Center",
    type: "Conference Center",
    img: "https://image2url.com/images/1757497141513-ae5c3c8d-7634-4d27-895b-1f39cf7292c1.jpg",   
    starrating: 4.6,
    location: "Chennai",
    capacity: 1000,
    rate: 3500,
    description: "Large convention center perfect for conferences",
    amenities: ["WiFi", "Sound System", "Multiple Rooms", "Catering", "Parking"],
    contactphone: "+1-555-0456",
    contactemail: "bookings@conventioncenter.com",
  },
  {
    id: 3,
    name: "Riverside Banquet",
    type: "Banquet",
    img: "https://image2url.com/images/1757497431556-1bb359c2-2e5a-4172-b120-65e8b860235d.jpg",
    starrating: 4.5,
    location: "Delhi",
    capacity: 300,
    rate: 1800,
    description: "Beautiful banquet hall with riverside views",
    amenities: ["Garden View", "Dance Floor", "Catering", "Parking"],
    contactphone: "+1-555-0789",
    contactemail: "events@riverside.com",
  },
  {
    id: 4,
    name: "Taj Lands End",
    type: "Hotel",
    img: "https://image2url.com/images/1757497431556-1bb359c2-2e5a-4172-b120-65e8b860235d.jpg",
    starrating: 5,
    location: "Mumbai",
    capacity: 1500,
    rate: 5000,
    description: "Beautiful hotelwith sea views",
    amenities: ["Garden View", "Dance Floor", "Catering", "Parking"],
    contactphone: "+1-555-0789",
    contactemail: "events@tajlandsend.com",
  },
  {
    id: 5,
    name: "The Oberoi",
    type: "Hotel",
    img: "https://image2url.com/images/1757497431556-1bb359c2-2e5a-4172-b120-65e8b860235d.jpg",
    starrating: 5,
    location: "Bengaluru",
    capacity: 300,
    rate: 2500,
    description: "Beautiful hotel in the city center",
    amenities: ["Garden View", "Dance Floor", "Catering", "Parking"],
    contactphone: "+1-555-0789",
    contactemail: "events@theoberoi.com",
  },
]
